import React from "react";

export function GstPrintableReport({ reportData, company, periodLabel }) {
  if (!reportData) return null;
  const { summary, tables } = reportData;

  const thStyle = {
    padding: "6px 8px",
    background: "#f3f4f6",
    borderBottom: "1px solid #d1d5db",
    fontSize: "10px",
    fontWeight: "700",
    color: "#374151",
    textAlign: "left"
  };

  const tdStyle = {
    padding: "6px 8px",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "10px",
    color: "#1f2937"
  };

  const sectionHeaderStyle = {
    fontSize: "11px",
    fontWeight: "800",
    color: "#1e3a8a",
    margin: "14px 0 6px 0",
    paddingBottom: "4px",
    borderBottom: "2px solid #bfdbfe",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  };

  return (
    <div
      className="gst-printable-report"
      style={{
        width: "100%",
        maxWidth: "760px",
        minWidth: "480px",
        margin: "0 auto",
        background: "#ffffff",
        color: "#111827",
        fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        boxSizing: "border-box"
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "2px solid #111827", paddingBottom: "10px", marginBottom: "12px" }}>
        <div>
          <h1 style={{ fontSize: "16px", fontWeight: "800", margin: 0, color: "#111827" }}>
            {company?.name || "SREE RAM TRADERS"}
          </h1>
          <div style={{ fontSize: "10px", color: "#4b5563", marginTop: "2px" }}>
            {company?.address || "33-C5, Pambalamman kovil street, Chettiyarpatti-626122"}
          </div>
          <div style={{ fontSize: "10px", color: "#4b5563" }}>
            Phone: {company?.phone || "9865460487"} | Email: {company?.email || "admin@webs8.com"}
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "13px", fontWeight: "800", color: "#1e40af", letterSpacing: "0.5px" }}>
            GST FILING REPORT
          </div>
          <div style={{ fontSize: "10px", fontWeight: "700", color: "#111827", marginTop: "2px" }}>
            GSTIN: {company?.gstin || "33AWFPA8086P1Z3"}
          </div>
          <div style={{ fontSize: "10px", color: "#4b5563" }}>
            Period: <strong>{periodLabel}</strong>
          </div>
          <div style={{ fontSize: "9px", color: "#6b7280" }}>
            Generated: {new Date().toLocaleDateString("en-IN")}
          </div>
        </div>
      </div>

      {/* SECTION 1: GSTR-3B Computation */}
      <div style={sectionHeaderStyle}>1. GSTR-3B Tax Computation & Net Cash Payable</div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
        <thead>
          <tr>
            <th style={thStyle}>Transaction Nature</th>
            <th style={{ ...thStyle, textAlign: "right" }}>Taxable (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>CGST (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>SGST (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>IGST (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>Total Tax (₹)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>Outward Taxable Sales (Supplies)</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>{summary.totalSalesTaxable.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>{summary.salesTax.cgst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>{summary.salesTax.sgst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>{summary.salesTax.igst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right", fontWeight: "700" }}>{summary.salesTax.total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
          </tr>
          <tr>
            <td style={tdStyle}>Inward Eligible ITC (Purchases)</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>{summary.totalPurchasesTaxable.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>{summary.purchasesItc.cgst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>{summary.purchasesItc.sgst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>{summary.purchasesItc.igst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right", fontWeight: "700", color: "#047857" }}>{summary.purchasesItc.total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
          </tr>
          <tr style={{ background: "#fef3c7" }}>
            <td style={{ ...tdStyle, fontWeight: "800", color: "#92400e" }}>NET TAX PAYABLE IN CASH</td>
            <td style={{ ...tdStyle, textAlign: "right" }}>-</td>
            <td style={{ ...tdStyle, textAlign: "right", fontWeight: "700" }}>₹{summary.netPayable.cgst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right", fontWeight: "700" }}>₹{summary.netPayable.sgst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right", fontWeight: "700" }}>₹{summary.netPayable.igst.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            <td style={{ ...tdStyle, textAlign: "right", fontWeight: "800", color: "#b45309" }}>₹{summary.netPayable.total.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
          </tr>
        </tbody>
      </table>

      {/* SECTION 2: GSTR-1 Table 4 B2B Invoices */}
      <div style={sectionHeaderStyle}>2. GSTR-1 Table 4 - B2B Invoices Register ({tables.b2bInvoices.length})</div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
        <thead>
          <tr>
            <th style={thStyle}>Inv #</th>
            <th style={thStyle}>Date</th>
            <th style={thStyle}>Customer Name</th>
            <th style={thStyle}>GSTIN</th>
            <th style={{ ...thStyle, textAlign: "right" }}>Taxable (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>CGST (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>SGST (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>Total (₹)</th>
          </tr>
        </thead>
        <tbody>
          {tables.b2bInvoices.length === 0 ? (
            <tr><td colSpan={8} style={{ ...tdStyle, textAlign: "center", color: "#6b7280" }}>No B2B invoices in this period</td></tr>
          ) : (
            tables.b2bInvoices.map((inv) => (
              <tr key={inv.id}>
                <td style={{ ...tdStyle, fontWeight: "600" }}>{inv.invoiceNo}</td>
                <td style={tdStyle}>{inv.invoiceDate}</td>
                <td style={tdStyle}>{inv.customerName}</td>
                <td style={{ ...tdStyle, fontFamily: "monospace", fontSize: "9px" }}>{inv.customerGstin}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>{inv.taxableValue.toFixed(2)}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>{inv.cgst.toFixed(2)}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>{inv.sgst.toFixed(2)}</td>
                <td style={{ ...tdStyle, textAlign: "right", fontWeight: "600" }}>{inv.grandTotal.toFixed(2)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* SECTION 3: HSN/SAC Summary */}
      <div style={sectionHeaderStyle}>3. GSTR-1 Table 12 - HSN / SAC Summary ({tables.hsnSummary.length})</div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
        <thead>
          <tr>
            <th style={thStyle}>HSN Code</th>
            <th style={thStyle}>Description</th>
            <th style={thStyle}>UQC</th>
            <th style={{ ...thStyle, textAlign: "right" }}>Qty</th>
            <th style={{ ...thStyle, textAlign: "right" }}>Taxable (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>CGST (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>SGST (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>Total Value (₹)</th>
          </tr>
        </thead>
        <tbody>
          {tables.hsnSummary.length === 0 ? (
            <tr><td colSpan={8} style={{ ...tdStyle, textAlign: "center", color: "#6b7280" }}>No HSN items recorded</td></tr>
          ) : (
            tables.hsnSummary.map((hsn) => (
              <tr key={hsn.hsnCode}>
                <td style={{ ...tdStyle, fontWeight: "600" }}>{hsn.hsnCode}</td>
                <td style={tdStyle}>{hsn.description}</td>
                <td style={tdStyle}>{hsn.unit}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>{hsn.totalQty}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>{hsn.taxableValue.toFixed(2)}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>{hsn.cgst.toFixed(2)}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>{hsn.sgst.toFixed(2)}</td>
                <td style={{ ...tdStyle, textAlign: "right", fontWeight: "600" }}>{hsn.totalValue.toFixed(2)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* SECTION 4: Inward Purchases (ITC) */}
      <div style={sectionHeaderStyle}>4. Inward Purchases ITC Register ({tables.purchaseRegister.length})</div>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
        <thead>
          <tr>
            <th style={thStyle}>Bill #</th>
            <th style={thStyle}>Date</th>
            <th style={thStyle}>Vendor Name</th>
            <th style={thStyle}>GSTIN</th>
            <th style={{ ...thStyle, textAlign: "right" }}>Taxable (₹)</th>
            <th style={{ ...thStyle, textAlign: "right" }}>ITC Tax (₹)</th>
            {summary.totalPurchasesTcs > 0 && <th style={{ ...thStyle, textAlign: "right" }}>TCS (₹)</th>}
            <th style={{ ...thStyle, textAlign: "right" }}>Total (₹)</th>
          </tr>
        </thead>
        <tbody>
          {tables.purchaseRegister.length === 0 ? (
            <tr><td colSpan={summary.totalPurchasesTcs > 0 ? 8 : 7} style={{ ...tdStyle, textAlign: "center", color: "#6b7280" }}>No purchases in this period</td></tr>
          ) : (
            tables.purchaseRegister.map((pur) => (
              <tr key={pur.id}>
                <td style={{ ...tdStyle, fontWeight: "600" }}>{pur.vendorBillNo}</td>
                <td style={tdStyle}>{pur.billDate}</td>
                <td style={tdStyle}>{pur.vendorName}</td>
                <td style={{ ...tdStyle, fontFamily: "monospace", fontSize: "9px" }}>{pur.vendorGstin}</td>
                <td style={{ ...tdStyle, textAlign: "right" }}>{pur.taxableValue.toFixed(2)}</td>
                <td style={{ ...tdStyle, textAlign: "right", fontWeight: "700", color: "#047857" }}>{pur.totalTax.toFixed(2)}</td>
                {summary.totalPurchasesTcs > 0 && <td style={{ ...tdStyle, textAlign: "right" }}>{pur.tcs.toFixed(2)}</td>}
                <td style={{ ...tdStyle, textAlign: "right" }}>{pur.grandTotal.toFixed(2)}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Signatory */}
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px", paddingTop: "10px", borderTop: "1px dashed #9ca3af" }}>
        <div style={{ fontSize: "9px", color: "#6b7280" }}>
          * Computer-generated report reconciled from internal invoices & purchase bills.
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "10px", fontWeight: "700" }}>For {company?.name || "SREE RAM TRADERS"}</div>
          <div style={{ height: "30px" }} />
          <div style={{ fontSize: "9px", color: "#4b5563" }}>Authorized Signatory / Tax Consultant</div>
        </div>
      </div>
    </div>
  );
}
